export default "__VITE_ASSET__CJcrvOsU__"